import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./languages/en.json";
import heTranslation from "./languages/he.json";

const savedLang = (localStorage.getItem("language") as "he" | "en") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      he: { translation: heTranslation },
    },
    lng: savedLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

document.documentElement.dir = savedLang === "he" ? "ltr" : "rtl";

export default i18n;
